var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarsSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-design",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6,29.5H84.4a2.7,2.7,0,0,0,2.7-2.7V20.2a2.7,2.7,0,0,0-2.7-2.6H15.6a2.7,2.7,0,0,0-2.7,2.6v6.6A2.7,2.7,0,0,0,15.6,29.5Zm0,26.5H84.4a2.7,2.7,0,0,0,2.7-2.7V46.7A2.7,2.7,0,0,0,84.4,44H15.6a2.7,2.7,0,0,0-2.7,2.7v6.6A2.7,2.7,0,0,0,15.6,56Zm0,26.4H84.4a2.7,2.7,0,0,0,2.7-2.6V73.2a2.7,2.7,0,0,0-2.7-2.7H15.6a2.7,2.7,0,0,0-2.7,2.7v6.6A2.7,2.7,0,0,0,15.6,82.4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsSolid);
export default __webpack_public_path__ + "static/media/bars-solid.a276be6d.svg";
export { ForwardRef as ReactComponent };